import React from 'react';
import { Panel, BarRow } from './parts';

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40);

const Rows = ({ rows, valueKey, total, prefix, empty }) => {
  if (!rows.length) return <p className="text-sm text-slate-400">{empty}</p>;
  const max = total || Math.max(...rows.map((r) => r[valueKey]));
  return (
    <div className="space-y-3">
      {rows.map((r) => (
        <BarRow key={r.label} label={r.label} count={r[valueKey]} pct={max ? Math.round((r[valueKey] / max) * 1000) / 10 : 0} testId={`${prefix}-${slug(r.code || r.label)}`} />
      ))}
    </div>
  );
};

export const TopPages = ({ pages }) => (
  <Panel title="Top pages · visitors" testId="growth-top-pages">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <div className="text-xs font-semibold text-slate-500 mb-2">Marketing pages</div>
        <Rows rows={pages.marketing} valueKey="visitors" prefix="growth-page" empty="No visits yet." />
      </div>
      <div>
        <div className="text-xs font-semibold text-slate-500 mb-2">League pages</div>
        <Rows rows={pages.league} valueKey="visitors" prefix="growth-league-page" empty="No visits yet." />
      </div>
    </div>
  </Panel>
);

export const Breakdown = ({ title, rows, total, prefix, testId, note }) => (
  <Panel title={title} testId={testId}>
    <Rows rows={rows} valueKey="count" total={total} prefix={prefix} empty="No visits yet." />
    {note && <p className="text-xs text-slate-400 mt-4">{note}</p>}
  </Panel>
);
